import { render } from "./UserInfoSectionNonyuCmp.vue?vue&type=template&id=c3a056f8&scoped=true"
import script from "./UserInfoSectionNonyuCmp.vue?vue&type=script&lang=js"
export * from "./UserInfoSectionNonyuCmp.vue?vue&type=script&lang=js"

import "../css/UserInfoSectionNonyu.css?vue&type=style&index=0&id=c3a056f8&scoped=true&lang=css"
import "./UserInfoSectionNonyuCmp.vue?vue&type=style&index=1&id=c3a056f8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src991838332/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/splats-mypage-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3a056f8"]])

export default __exports__